<div class="h-100 w-100 mb-2">
  <div class="filter">
    <div class="filter-gap -generic-filter-fields">
      <div>
        <mat-form-field class="field" appearance="outline">
          <mat-label>Page Size</mat-label>
          <mat-select [formControl]="pageSize" panelClass="multiSelectPanel">
            <mat-option *ngFor="let item of pageSizeLimit" [value]="item" (click)="onPageLimitChange()">
              {{item}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field class="field" appearance="outline">
          <mat-label>Period Filter</mat-label>
          <mat-select [formControl]="period" panelClass="multiSelectPanel">
            <mat-option *ngFor="let item of periodList" [value]="item" (click)="onPeriodFilterChange()">
              {{item.name | titlecase}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div (click)="exportData()" class="d-flex img-cntr" *ngIf="exportNeeded">
      <img src="../../../../assets/images/export-idec.svg" title="export" alt="export" class="h-40 cursor">
    </div>
  </div>